<template>
  <v-dialog v-model="propModel" width="500">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ title ? title : $t('label.delete') }}
      </v-card-title>

      <v-card-text class="mt-3">
        <slot></slot>  
        <div v-if="!$slots.default">
          {{ $t('label.are_you_sure') }}
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="propModel = false"
        >
          {{ $t('label.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          @click="propModel = false; $emit('delete-object', id)"
        >
          <v-icon class="mr-2">mdi-trash-can</v-icon>
          {{ $t('label.delete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  components: {
  },

  props: {
    value: false,
    title: {
      type: "",
    },
    id: {
      type: ""
    }
  },

  computed: {
    propModel: {
      get () { return this.value },
      set (value) { this.$emit('input', value) },
  },
},


});
</script>

<style scoped lang="scss">
</style>
